import React from 'react';
import theme from './BuyerDocumentIcon.module.scss';
import { useDocumentType } from '@/utils/hooks';
import { FileIcon } from '@ygtechnologies/bygr-frontend-component-library';
import { getOpenDocumentUrl } from '@/services/documents';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BuyerDocument, FileMetadata } from '@/types';
import { faBuilding, faHome } from '@fortawesome/pro-light-svg-icons';

export interface BuyerDocumentIconProps {
    fileMetadata: FileMetadata;
}

// export const BuyerDocumentIcon: React.FC<BuyerDocumentIconProps> = ({ document }) => {
//     const documentType = useDocumentType(document.documentTypeId);

//     return (
//         <div className={theme.container}>
//             <FileIcon fixedWidth className={theme.fileIcon} value={document.fileMetadata} />
//             <a
//                 className={'link-unstyled'}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 href={getOpenDocumentUrl(document.versionId)}>
//                 <span>
//                     <FontAwesomeIcon icon={document.isProjectDocument ? faBuilding : faHome} />
//                     <span className={theme.documentName}>{document.name}</span>
//                 </span>
//                 <span className={theme.muted}>{documentType?.name}</span>
//             </a>
//         </div>
//     );
// };

export const BuyerDocumentIcon: React.FC<BuyerDocumentIconProps> = ({ fileMetadata }) => {
    return <FileIcon fixedWidth className={theme.fileIcon} value={fileMetadata} />;
};
